import { handleSpecsDownload } from "@/components/ProductDetail/v3/ProductAccordionList/Specs/utils"
import SetListData from "@/components/ProductDetail/v3/ProductAccordionList/SetListData"
import RowData from "@/components/ProductDetail/v3/ProductAccordionList/RowData"
import downloadIcon from "@/public/icons/download-dark-gray.svg"

const Specs = props => {
  const {
    data: { techFiles, specsDetails, productAccordionText, productInfo } = {},
    dimensionsData = [],
    config = {},
  } = props

  return (
    <>
      <div className="pdp-technical-tile__files --specs-info">
        {techFiles.map((item, i) => (
          <section key={i}>
            <div
              className="pdp-technical-tile__file"
              role="link"
              tabIndex={0}
              onClick={e => handleSpecsDownload(e, item.title, item.url, productInfo)}
            >
              <img alt="" aria-hidden="true" src={downloadIcon?.src} />
              <span>{item.title}</span>
            </div>
          </section>
        ))}
      </div>
      {dimensionsData.length ? (
        <div className="pdp-dimensions__specs">
          <RowData
            data={dimensionsData}
            accordionType={"specifications"}
            productInfo={productInfo}
            config={config}
          />
        </div>
      ) : null}
      {specsDetails.map(
        (subCategory, i) =>
          subCategory.specList.length > 0 && (
            <div key={i} className="pdp-spec-detail__container">
              <p className="pdp-spec-detail__title">{subCategory.specTitle}</p>
              <SetListData
                listData={subCategory.specList}
                showType={subCategory.specTitle}
                productAccordionText={productAccordionText}
                productInfo={productInfo}
                tabName={"specs"}
              />
            </div>
          )
      )}
    </>
  )
}

export default Specs
